import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureReferralClick } from "../lib/referralClient";

/**
 * Mounted once near the app root (alongside GAPageViewTracker). Captures the
 * `?ref=CODE` query param on ANY page — supports the
 * `traindriverfoundation.com/?ref=ABC123` link style in addition to the
 * dedicated `/r/:code` route.
 */
export default function ReferralClickTracker() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ref = params.get("ref");
    if (ref) {
      captureReferralClick(ref, location.pathname + location.search);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, location.pathname]);

  return null;
}
